import { useSelector } from 'react-redux';
import { useClearAlertMessages } from '../../shared/components/AlertGroup/useAccountAlerts';
import Overlay from '../../shared/components/Overlay';
import usePermissions from '../../shared/hooks/usePermissions';
import { useGetAccountDataQuery } from '../../shared/navigation/apiSlice';
import PERMISSIONS from '../../shared/permissions';
import { accountSelector } from '../../shared/store/shared/accountSlice';
import AccessRules from './AccessRules';
import AccountName from './AccountName';
import AccountSupportContact from './AccountSupportContact';
import AgreementSettings from './AgreementSettings';
import CustomAlertCard from './CustomAlertCard';
import LogoUploadCard from './LogoUpload/LogoUploadCard';
import TwofaCadence from './TwofaCadence';
import WelcomeMessageCard from './WelcomeMessage/WelcomeMessageCard';

export default function Settings() {
  useClearAlertMessages();
  const { currentAccountId } = useSelector(accountSelector);
  const { isLoading, isFetching } = useGetAccountDataQuery(currentAccountId);
  const { hasAccess } = usePermissions();

  return (
    <>
      <div className="row gy-4">
        <div className="col-12">
          <AccountName />
        </div>
        <AccountSupportContact accountId={currentAccountId} />
        <AgreementSettings accountId={currentAccountId} />
        {hasAccess({ permissions: [PERMISSIONS.ManagePMIDeveloper] }) && (
          <div className="col-12">
            <CustomAlertCard />
          </div>
        )}
        <div className="col-12">
          <AccessRules />
        </div>
        <div className="col-12">
          <LogoUploadCard />
        </div>
        <div className="col-12">
          <TwofaCadence />
        </div>
        <div className="col-12">
          <WelcomeMessageCard />
        </div>
      </div>
      <Overlay
        variant="PMIOverlay"
        global
        animated
        fade
        iconColor="brand-dark"
        overlayColor="black"
        overlayOpacity={1}
        show={isLoading || isFetching}
      />
    </>
  );
}
